const httpUrl = 'https://www.hbnanjun.com/api'
// const httpUrl = 'http://121.37.175.51:8085'

export default {
    httpUrl,
}